<template>
  <div class="upload-img-list">
    <div>
      <draggable :list="value" animation="100">
        <div v-for="(_, i) of value" :key="i">
          <upload-img-list-item
            v-model="value[i]"
            :haveImg="haveImg"
            :haveTitle="haveTitle"
            :jumpType="jumpType"
            :haveJump="haveJump"
            :titleMaxLength="titleMaxLength"
          >
            <template #rightContent>
              <slot name="childRightContent" v-bind:i="i"> </slot>
            </template>
          </upload-img-list-item>
          <i
            v-if="i + 1 - minLength !== 0"
            class="el-icon-error"
            @click="deleteItem(i)"
          ></i>
        </div>
      </draggable>
    </div>

    <el-button
      icon="el-icon-plus"
      class="add-btn"
      @click="add"
      v-show="value.length !== maxLength"
      >{{ addBtnText }}（{{ value.length }}/{{ maxLength }}）</el-button
    >
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { deepCopy } from "../utils/utils";
import UploadImgListItem from "./UploadImgListItem";
export default {
  components: {
    draggable,
    UploadImgListItem
  },
  props: {
    value: {
      type: Array,
      require: true
    },
    maxLength: {
      type: Number,
      default: 1
    },
    minLength: {
      type: Number,
      default: 1
    },
    haveImg: {
      type: Boolean,
      default: true
    },
    haveTitle: {
      type: Boolean,
      default: false
    },
    // 是否有跳转
    haveJump: {
      type: Boolean,
      default: true
    },
    // url or component
    jumpType: {
      type: String,
      default: "url"
    },
    addBtnText: {
      type: String,
      default: "添加图片"
    },
    // 需要添加的数据模板
    templateParams: {
      type: Object,
      default: () => {}
    },
    titleMaxLength: {
      type: Number,
      default: 6
    }
  },
  watch: {
    // 防止有些组件不同长度类型切换时产生多出来问题
    maxLength(val) {
      const length = this.value.length;
      if (length > val) {
        let gap = length - val;
        while (gap > 0) {
          this.deleteItem(this.value.length - 1);
          gap--;
        }
      }
    }
  },
  methods: {
    add() {
      const { maxLength } = this;
      const length = this.value.length;
      if (length >= maxLength) {
        this.$message.info(`最多只能添加${maxLength}个`);
        return;
      }
      const params = [...this.value, deepCopy(this.templateParams)];
      this.$emit("input", params);
    },

    deleteItem(i) {
      const params = this.value;
      params.splice(i, 1);
      this.$emit("input", params);
    }
  }
};
</script>

<style lang="less" scoped>
.upload-img-list {
  > div {
    margin-bottom: 16px;
    > div {
      > div {
        position: relative;
        cursor: pointer;
        /deep/ .content {
          margin-bottom: 10px;
        }
        > .el-icon-error {
          font-size: 16px;
          color: #bbbbbb;
          position: absolute;
          top: -8px;
          right: -8px;
          cursor: pointer;
        }
      }
    }
  }
  /deep/ .add-btn {
    width: 332px;
    height: 30px;
    background: #ffffff;
    border-radius: 2px;
    border: 1px solid #2154f4;
    color: #2154f4;
    font-size: 12px;
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/components/UploadImgList.vue